import styled from 'styled-components';
import Colors from 'assets/Colors';

const PageContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  /* max-width: 1136px; */
`;

const Container = styled.div`
width: 100%;
background: ${Colors.background_secondary};
border - radius: 2px;
max - width: 100vw;
`;

const ChartComponentsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  @media (max-width: 1390px) {
    flex-direction: column;
  }
`;

const textDate = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${Colors.text_primary};
`;
const textLight = styled.div`
  margin-top: -31px;
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_secondary};
`;

export default {
  textDate,
  Container,
  textLight,
  PageContainer,
  ChartComponentsWrapper,
};
